import { render, staticRenderFns } from "./card-avg-viewing-time.vue?vue&type=template&id=ddb80962&"
import script from "./card-avg-viewing-time.vue?vue&type=script&lang=js&"
export * from "./card-avg-viewing-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports